/* eslint-disable @typescript-eslint/naming-convention */
import { createContext, useContext } from "react";

export type SplitterItemPropertyName = "size" | "min" | "max" | "collapsed";
export type SplitterItemPropertyValue = string | boolean;
export type SplitterContextType = (
  index: number,
  propertyName: SplitterItemPropertyName,
  oldValue?: SplitterItemPropertyValue,
  newValue?: SplitterItemPropertyValue,
) => void;
export const SplitterContext = createContext<SplitterContextType | null>(null);
export const SplitterIndexContext = createContext<number | null>(null);

export const useSplitterItem = () => {
  const splitterContext = useContext(SplitterContext);
  const index = useContext(SplitterIndexContext);
  if (!splitterContext || index === null) throw new Error("useSplitterItem must be used inside SmetaSplitter");
  return (
    propertyName: SplitterItemPropertyName,
    oldValue?: SplitterItemPropertyValue,
    newValue?: SplitterItemPropertyValue,
  ) => splitterContext(index, propertyName, oldValue, newValue);
};
